module.exports = __webpack_public_path__ + "img/siteview.abb2fbb9.png";